import React from 'react'
import BaseStep from '../BaseStep'
import CardSelectable from '../commons/CardSelectable'
import GenericIcon from 'components/GenericIcon'

class LoanPurpose extends BaseStep {

  onClick = (answer) => {
    this.props.onChoice({ loanPurpose: answer })
  }

  render() {
    return (
      <div ref={ (ref) => this.cardsContainer = ref } >
        <h3 className="onboarding-title text-center">
          { I18n.t('onboarding.loan_purpose.question') }
        </h3>
        <div className="row" >
          <div className="col-sm-6">
            <CardSelectable
              onMouseEnter={(e) => this.onMouseEnter(e) }
              onMouseLeave={() => this.onMouseLeave() }
              onClick={ () => this.onClick('refinance') }
            >
              <GenericIcon name='desktopDollar' />
              <h4>{ I18n.t('onboarding.loan_purpose.answer.refinance') }</h4>
            </CardSelectable>
          </div>
          <div className="col-sm-6">
            <CardSelectable
              onMouseEnter={(e) => this.onMouseEnter(e) }
              onMouseLeave={() => this.onMouseLeave() }
              onClick={ () => this.onClick('purchase') }
            >
            <GenericIcon name='smallHome' />
              <h4>{ I18n.t('onboarding.loan_purpose.answer.purchase') }</h4>
            </CardSelectable>
          </div>
        </div>
      </div>
    )
  }
}

export default LoanPurpose;
